/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * 
 * @export
 * @interface AddGuildBody
 */
export interface AddGuildBody {
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    groupingId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddGuildBody
     */
    games: Array<string>;
    /**
     * 
     * @type {EVMChain}
     * @memberof AddGuildBody
     */
    autoMintChain?: EVMChain;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    autoMintContract?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddGuildBody
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    bannerImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof AddGuildBody
     */
    bannerImageLarge?: string;
}



/**
 * Check if a given object implements the AddGuildBody interface.
 */
export function instanceOfAddGuildBody(value: object): value is AddGuildBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('groupingId' in value) || value['groupingId'] === undefined) return false;
    if (!('games' in value) || value['games'] === undefined) return false;
    return true;
}

export function AddGuildBodyFromJSON(json: any): AddGuildBody {
    return AddGuildBodyFromJSONTyped(json, false);
}

export function AddGuildBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddGuildBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupingId': json['groupingId'],
        'games': json['games'],
        'autoMintChain': json['autoMintChain'] == null ? undefined : EVMChainFromJSON(json['autoMintChain']),
        'autoMintContract': json['autoMintContract'] == null ? undefined : json['autoMintContract'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'hero': json['hero'] == null ? undefined : json['hero'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'bannerImageSmall': json['bannerImageSmall'] == null ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': json['bannerImageLarge'] == null ? undefined : json['bannerImageLarge'],
    };
}

export function AddGuildBodyToJSON(json: any): AddGuildBody {
    return AddGuildBodyToJSONTyped(json, false);
}

export function AddGuildBodyToJSONTyped(value?: AddGuildBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'groupingId': value['groupingId'],
        'games': value['games'],
        'autoMintChain': EVMChainToJSON(value['autoMintChain']),
        'autoMintContract': value['autoMintContract'],
        'isActive': value['isActive'],
        'hero': value['hero'],
        'icon': value['icon'],
        'bannerImageSmall': value['bannerImageSmall'],
        'bannerImageLarge': value['bannerImageLarge'],
    };
}

